const dekstopPlatforms =
  /Macintosh|Mac68K|MacPPC|MacIntel|Win32|Win64|Win16|Linux/
const mobileUA = /Android|iphone|iPad|Mobile|Windows Phone/

export const isUserDeviceDesktop = (platform, userAgent) =>
  dekstopPlatforms.test(platform) && !mobileUA.test(userAgent)
